<template>
  <div>
    <el-card>
      <BaseForm
        :formulaCode="params.formulaCode"
        :disabled="disabled"
        :isAddOperation="isAddOperation"
        ref="baseForm"
      />
      <div class="d2-mt d-flex justify-content-end">
        <el-button size="mini" type="primary" v-if="!disabled" @click="$refs.baseForm.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import BaseForm from './components/base-form'

export default {
  name: 'sample-sampleFormula-detail',
  components: { BaseForm },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        edit: '编辑核价公式信息',
        add: '添加核价公式信息',
        detail: '核价公式信息详情',
      }
      return types[this.pageType]
    },
    disabled() {
      return this.pageType === 'detail'
    },
    isAddOperation() {
      return this.pageType === 'add'
    },
  },
  // methods(){

  // },
}
</script>
